export default (tourCriteria) => {
    const tourCriteriaJson = {};
    const element = tourCriteria.get('hotels');

    if (element) {
        if (element.length) {
            tourCriteriaJson.hotels = element.pluck('id');
        } else {
            tourCriteriaJson.hotels = [];
        }
    }

    return tourCriteriaJson;
};